/** Rating-config admin API client */
import axios from 'axios'
import { attachAuth } from '../../lib/apiAuth'
import type { RatingConfig, RatingConfigTree, RatingCatalog, RatingPreview } from '../types'

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:8899'
const api = axios.create({ baseURL: `${API_BASE}/admin/rating-config`, headers: { 'Content-Type': 'application/json' } })

export async function getRatingConfig(): Promise<RatingConfig> { return (await api.get('')).data }
export async function saveRatingConfig(config: RatingConfigTree): Promise<RatingConfig> { return (await api.put('', { config })).data }
export async function resetRatingConfig(): Promise<RatingConfig> { return (await api.post('/reset')).data }
export async function getRatingCatalog(): Promise<RatingCatalog> { return (await api.get('/catalog')).data }
export async function previewRating(ags: string): Promise<RatingPreview> { return (await api.get('/preview', { params: { ags } })).data }

// Basic-Auth-Header + 401-Behandlung (optionaler Schutz, v0.3.8)
attachAuth(api)
